import React from 'react';

interface HeroProps {
  onGetStarted: () => void;
}

const Hero: React.FC<HeroProps> = ({ onGetStarted }) => {
  return (
    <section className="container mx-auto px-8 pt-0 pb-10 grid lg:grid-cols-2 gap-6 items-center" style={{ transform: 'translate(0px, -20px)' }}>
      <div className="space-y-3">
        <h1 className="text-4xl lg:text-5xl font-bold text-white leading-tight">
          Van idee naar live
          <br />
          <span className="text-white">website of app in 30 dagen</span>
        </h1>

        <p className="text-lg text-gray-200">
          Transparante prijzen vanaf €795. Geen verrassingen, geen verborgen kosten.
        </p>

        <button
          onClick={onGetStarted}
          className="text-white px-6 py-2.5 rounded-lg font-semibold transition transform hover:scale-105 shadow-lg"
          style={{
            background: 'radial-gradient(circle at center, #ff8a3d 0%, #f06c28 45%, #d4551b 100%)',
          }}
        >
          Vraag Offerte Aan
        </button>

      </div>

      <div className="relative">
        <div className="space-y-2">
          {/* Main device display */}
          <div className="relative">
            <div className="animate-float">
              <img
                src="/portfolio-example-1.png"
                alt="Buurtbeveiliging Project"
                className="drop-shadow-2xl"
                style={{ width: '110%', maxWidth: '110%', marginLeft: '-5%' }}
              />
            </div>

            {/* Orange gradient banner with mobile device outside on the left */}
            <div className="absolute top-1/4 -left-20 right-10 transform -translate-y-1/4 z-20 flex items-center">
              {/* Rockerroe mobile device - 15% larger */}
              <img
                src="/portfolio-example-2.png"
                alt="Mobile App"
                className="w-72 h-auto drop-shadow-2xl -mr-36 z-30 mt-9 pointer-events-none"
              />
              <div
                className="py-2.5 px-14 shadow-lg rounded-full"
                style={{
                  background: 'radial-gradient(circle at center, #ff8a3d 0%, #f06c28 45%, #d4551b 100%)',
                  width: '105%',
                  maxWidth: '900px'
                }}
              >
                <p className="text-white font-semibold text-center text-sm" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                  Bekijk{' '}
                  <a
                    href="https://buurtbeveiliging.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline font-bold hover:text-yellow-100 transition"
                  >
                    hier
                  </a>
                  {' '}meest recent gelanceerde project:<br/>
                  <span className="font-bold text-base">Buurtbeveiliging</span> <span className="text-xs">(Website + app)</span>
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;